import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { userSelector } from 'store/selectors';
import { PAGE_PATHS, ROLES } from '../constants';

/**
 * @description - HOC, that used to check user permission to visit pages
 * @param {Array} roles - valid list of roles
 * @param {Function} Page - page, need to be rendered
 */
const withAllowedRoles = (roles, Page) => props => {
  const user = useSelector(userSelector);

  if (user?.role) {
    if (roles.includes(user.role)) {
      return <Page {...props} />;
    }
    const defaultPage =
      user.role === ROLES.AGENT ? PAGE_PATHS.PRODUCT : PAGE_PATHS.JOB;
    return <Navigate to={defaultPage} />;
  }
  return null;
};

export default withAllowedRoles;
